import Vue from 'vue'
import VueRouter from 'vue-router'
import { isTokenValid, getTokenUserInfo } from '../utils/jwt-util';
// 导入组件
import TestView from '../views/TestView.vue'
import UserList from '../views/system/UserList.vue'
import RoleList from '../views/system/RoleList.vue'
import PermissionList from '../views/system/PermissionList.vue'
import DictionaryList from '../views/system/DictionaryList.vue'
import DictionaryItemList from '../views/system/DictionaryItemList.vue'
import OrganizationList from '../views/system/OrganizationList.vue'
import TargetList from '../views/device/TargetList.vue'
import ShootingActivityList from '../views/device/ShootingActivityList.vue'
import ShootingScoreList from '../views/device/ShootingScoreList.vue'
import ShooterList from '../views/device/ShooterList.vue' 
import ShootingScore from '../views/device/ShootingScore.vue'
import ShootingScorePK from '../views/device/ShootingScorePK.vue'
import RecordList from '../views/device/RecordList.vue'
import RecordDetail from '../views/device/RecordDetail.vue'
import ProductList from '../views/autoPay/ProductList.vue'
import ProductItemList from '../views/autoPay/ProductItemList.vue'
import SubMerchantList from '../views/autoPay/SubMerchantList.vue'
import PayOrderList from '../views/autoPay/PayOrderList.vue'
import PayOrderDetail from '../views/autoPay/PayOrderDetail.vue'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import MainLayout from '../views/layout/MainLayout.vue'
import Profile from '../views/Profile.vue'
import MenuList from '../views/system/MenuList.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'MainLayout',
    component: MainLayout,
    redirect: '/home',
    children: [
      {
        path: 'home',
        name: 'Home',
        component: Home
      },
      {
        path: 'system/user',
        name: 'UserList',
        component: UserList
      },
      {
        path: 'system/role',
        name: 'RoleList',
        component: RoleList
      },
      {
        path: 'system/permission',
        name: 'PermissionList',
        component: PermissionList
      },
      {
        path: 'system/dictionary',
        name: 'DictionaryList',
        component: DictionaryList,
      },
      {
        path: 'system/dictionaryItem',
        name: 'DictionaryItemList',
        component: DictionaryItemList,
        props: true
      },
      {
        path: 'system/organization',
        name: 'OrganizationList',
        component: OrganizationList
      },
      {
        path: 'device/target',
        name: 'TargetList',
        component: TargetList
      },
      {
        path: 'device/shootingScore',
        name: 'ShootingScore',
        component: ShootingScore,
        props: true,
        meta: {
          fullscreen: true // 标记为全屏页面
        }
      },
      {
        path: 'device/shootingScorePK',
        name: 'ShootingScorePK',
        component: ShootingScorePK,
        props: true,
        meta: {
          fullscreen: true // 标记为全屏页面
        }
      },
      {
        path: 'device/recordDetail',
        name: 'RecordDetail',
        component: RecordDetail,
        props: true,
        meta: {
          fullscreen: true // 标记为全屏页面
        }
      },
      {
        path: 'autoPay/product',
        name: 'ProductList',
        component: ProductList
      },
      {
        path: 'autoPay/productItem',
        name: 'ProductItemList',
        component: ProductItemList,
        props: true
      },
      {
        path: 'autoPay/subMerchant',
        name: 'SubMerchantList',
        component: SubMerchantList
      },
      {
        path: 'autoPay/payOrder',
        name: 'PayOrderList',
        component: PayOrderList
      },
      {
        path: 'autoPay/payOrderDetail',
        name: 'PayOrderDetail',
        component: PayOrderDetail,
        props: true
      },
      {
        path: 'device/shootingActivity',
        name: 'ShootingActivityList',
        component: ShootingActivityList
      },
      {
        path: 'device/shooter',
        name: 'ShooterList',
        component: ShooterList,
        props: true
      },
      {
        path: 'device/recordList',
        name: 'RecordList',
        component: RecordList,
        props: true
      },
      {
        path: 'device/shootingScoreList',
        name: 'ShootingScoreList',
        component: ShootingScoreList,
        props: true,
        meta: {
          fullscreen: true // 标记为全屏页面
        }
      },
      {
        path: 'profile',
        name: 'Profile',
        component: Profile
      },
      {
        path: 'system/menu',
        name: 'MenuList',
        component: MenuList
      },
    ]
  },
  {
    path: '/test',  // 测试页面路由
    name: 'Test',
    component: TestView
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  }
]

const router = new VueRouter({
  routes
})

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    // 只忽略重复导航的错误
    if (err.name !== 'NavigationDuplicated') {
      throw err
    }
  })
}

// 添加路由守卫
import store from '../store'
router.beforeEach(async (to, from, next) => {
  // 从sessionStorage获取JWT令牌
  const token = sessionStorage.getItem('token');
  
  // 如果访问的是登录页，直接放行
  if (to.path === '/login') {
    next();
    return;
  }
  
  // 验证令牌有效性
  const isValid = isTokenValid(token);
  if (!isValid) {
    next('/login');
    return;
  }

  // 已登录时，若从登录页跳转而来（说明是刚登录成功），直接放行
  // 避免与登录后的push('/home')形成循环
  if (from.path === '/login') {
    await store.dispatch('fetchUserInfo');
    next();
    return;
  }
  
  // 已登录，放行
  await store.dispatch('fetchUserInfo');
  next();
});

export default router
